import React, {FC, useEffect, useState} from "react";
import Link from "../../vida-link";

const IRWorkshopInstructionalLibrarySidebar: FC = () => {
  const [show, setShow] = useState("");
  const [currentHash, setCurrentHash] = useState("");

  useEffect(() => {
    function updateHash() {
      const hash = window.location.hash;
      setCurrentHash(hash);
    }

    // Run when the page is loaded
    updateHash()
    // Run when hash changes (hash changes dont cause force-reload)
    window.addEventListener('hashchange', updateHash)
    // Cleanup
    return () =>
      window.removeEventListener('hashchange', updateHash)
  }, [])

  const toggle = (newShow: string) => {
    if (show === newShow) {
      setShow("");
    } else {
      setShow(newShow);
    }
  }

  return <>
    <div className="vida-sidebar">
      <div className="sidebar-group">
        <h3>
          <Link href="/vida/ir-workshop-instructional-library" hash={currentHash}><a>IR Workshop Instructional
            Library</a></Link>
        </h3>
        <ul>
          <li>
            <div className="sidebar-group">
              <h3>
                <a onClick={() => toggle("using-vida")}><strong>Using VIDA</strong></a>
              </h3>
              {show === "using-vida" &&
                <ul>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#vin-profiling" activeClass="active"
                          hash={currentHash}>
                      <a>VIN Profiling</a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#repair-topics-and-description"
                          activeClass="active" hash={currentHash}>
                      <a>Repair Topics and Description</a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#getting-to-repair-information"
                          activeClass="active" hash={currentHash}>
                      <a>Getting to repair information</a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#diagnostic-protocols" activeClass="active"
                          hash={currentHash}>
                      <a>Diagnostic Protocols</a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#advanced-test" activeClass="active"
                          hash={currentHash}>
                      <a>Advanced test</a>
                    </Link>
                  </li>
                </ul>
              }
            </div>
          </li>
          <li>
            <div className="sidebar-group">
              <h3>
                <a onClick={() => toggle("spa-platform-and-later-wiring-diagrams")}><strong>SPA Platform and Later
                  Wiring Diagrams</strong></a>
              </h3>
              {show === "spa-platform-and-later-wiring-diagrams" &&
                <ul>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#wiring-component-functions"
                          activeClass="active" hash={currentHash}>
                      <a>Wiring Component Functions</a>
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/vida/ir-workshop-instructional-library#spa-platform-and-later-wiring-diagrams-subsection"
                      activeClass="active" hash={currentHash}>
                      <a>SPA Platform and later Wiring Diagrams</a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#finding-the-location-of-a-fuse-or-relay"
                          activeClass="active" hash={currentHash}>
                      <a>Finding the location of a fuse or relay</a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#finding-the-fuse-for-a-component"
                          activeClass="active" hash={currentHash}>
                      <a>Finding the Fuse for a component</a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#finding-information-on-the-components-page"
                          activeClass="active" hash={currentHash}>
                      <a>Finding information on the Components page</a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#finding-components-per-fuse"
                          activeClass="active" hash={currentHash}>
                      <a>Finding components per fuse</a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#fault-tracing-a-vehicles-network"
                          activeClass="active" hash={currentHash}>
                      <a>Fault Tracing a Vehicles Network</a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#fault-tracing-a-vehicle-using-wiring-diagrams"
                          activeClass="active" hash={currentHash}>
                      <a>Fault tracing a Vehicle using wiring diagrams</a>
                    </Link>
                  </li>
                </ul>
              }
            </div>
          </li>
          <li>
            <div className="sidebar-group">
              <h3>
                <a onClick={() => toggle("spa-platform-and-later-vds-fault-tracing")}><strong>SPA Platform and Later
                  (VDS) Fault Tracing</strong></a>
              </h3>
              {show === "spa-platform-and-later-vds-fault-tracing" &&
                <ul>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#fault-tracing-a-vehicle-using-wiring-diagrams-2"
                          activeClass="active" hash={currentHash}>
                      <a>Fault tracing a Vehicle using wiring diagrams</a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#vin-profiling-2"
                          activeClass="active" hash={currentHash}>
                      <a>VIN Profiling</a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#troubleshooting-a-cable-connection-vds"
                          activeClass="active" hash={currentHash}>
                      <a>Troubleshooting a cable connection (VDS)</a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#spa-cma-vida-csc-fault-tracing-descriptive"
                          activeClass="active" hash={currentHash}>
                      <a>SPA CMA VIDA CSC fault tracing descriptive</a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#finding-the-location-of-a-component"
                          activeClass="active" hash={currentHash}>
                      <a>Finding the location of a component</a>
                    </Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#fault-tracing-a-vehicles-network-2"
                          activeClass="active" hash={currentHash}>
                      <a>Fault Tracing a Vehicles Network</a>
                    </Link>
                  </li>
                </ul>
              }
            </div>
          </li>
          <li>
            <div className="sidebar-group">
              <h3>
                <a onClick={() => toggle("software-download")}><strong>Software Download</strong></a>
              </h3>
              {show === "software-download" &&
                <ul>
                  <li>
                    <Link
                      href="/vida/ir-workshop-instructional-library#downloads-workshop-and-vehicle-preparedness"
                      activeClass="active" hash={currentHash}>
                      <a>Downloads, Workshop and Vehicle preparedness</a>
                    </Link>
                  </li>
                  <li>
                    <Link
                      href="/vida/ir-workshop-instructional-library#software-download-job-aid"
                      activeClass="active" hash={currentHash}>
                      <a>Software Download Job Aid</a>
                    </Link>
                  </li>
                </ul>
              }
            </div>
          </li>
          <li>
            <div className="sidebar-group">
              <h3>
                <a onClick={() => toggle("platform-identification")}><strong>Platform Identification</strong></a>
              </h3>
              {show === "platform-identification" &&
                <ul>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#spa-and-cma-platform-identification"
                          activeClass="active" hash={currentHash}><a>SPA and CMA platform Identification</a></Link>
                  </li>
                </ul>
              }
            </div>
          </li>
          <li>
            <div className="sidebar-group">
              <h3>
                <a onClick={() => toggle("network-fault-tracing-overview")}><strong>Network Fault Tracing
                  Overview</strong></a>
              </h3>
              {show === "network-fault-tracing-overview" &&
                <ul>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#network-fault-tracing-overview-vds"
                          activeClass="active" hash={currentHash}><a>Network fault tracing overview VDS</a></Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#network-fault-tracing-d2-and-ggd"
                          activeClass="active" hash={currentHash}><a>Network fault tracing (D2 and GGD)</a></Link>
                  </li>
                </ul>
              }
            </div>
          </li>
          <li>
            <div className="sidebar-group">
              <h3>
                <a onClick={() => toggle("module-recovery-general")}><strong>Module Recovery (General)</strong></a>
              </h3>
              {show === "module-recovery-general" &&
                <ul>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#p1-and-p2-can-module-recovery-procedure"
                          activeClass="active" hash={currentHash}><a>P1 and P2 CAN Module Recovery Procedure</a></Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#module-recovery"
                          activeClass="active" hash={currentHash}><a>Module recovery</a></Link>
                  </li>
                </ul>
              }
            </div>
          </li>
          <li>
            <div className="sidebar-group">
              <h3>
                <a onClick={() => toggle("connecting-p3-vehicles-and-previous-using-dice")}><strong>Connecting P3
                  Vehicles and Previous using DiCE</strong></a>
              </h3>
              {show === "connecting-p3-vehicles-and-previous-using-dice" &&
                <ul>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#print-service-checkList"
                          activeClass="active" hash={currentHash}><a>Print Service CheckList</a></Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#installing-the-usb-driver-for-dice"
                          activeClass="active" hash={currentHash}><a>Installing the USB driver for DiCE</a></Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#dice-firmware"
                          activeClass="active" hash={currentHash}><a>DiCE Firmware</a></Link>
                  </li>
                  <li>
                    <Link
                      href="/vida/ir-workshop-instructional-library#connecting-dice-for-ggd-and-d2-vehicle-p3-or-older"
                      activeClass="active" hash={currentHash}><a>Connecting DiCE for GGD and D2 Vehicle P3 or older</a></Link>
                  </li>
                </ul>
              }
            </div>
          </li>
          <li>
            <div className="sidebar-group">
              <h3>
                <a onClick={() => toggle("connecting-spa-or-cma-platform-vehicles")}><strong>Connecting SPA or CMA
                  Platform Vehicles</strong></a>
              </h3>
              {show === "connecting-spa-or-cma-platform-vehicles" &&
                <ul>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#car-connection-spa-cma-platform"
                          activeClass="active" hash={currentHash}><a>Car Connection SPA CMA Platform</a></Link>
                  </li>
                  <li>
                    <Link href="/vida/ir-workshop-instructional-library#connecting-a-vehicle-vds-spa-and-cma-platform"
                          activeClass="active" hash={currentHash}><a>Connecting a vehicle (VDS) SPA and CMA platform</a></Link>
                  </li>
                </ul>
              }
            </div>
          </li>
        </ul>
      </div>
    </div>
    <style jsx>{`
      .vida-sidebar {
        padding: 3rem 3rem;
        position: fixed;
        font-family: 'Volvo Novum', sans-serif;
      }

      h3 {
        margin: 0;
      }

      .sidebar-group h3 :global(a) {
        color: #333;
        text-decoration: none;
        transition: all 200ms ease-in-out;
        font-weight: 500;
        cursor: pointer;
      }

      .sidebar-group h3 :global(a:hover) {
        color: #707070;
      }

      strong {
        font-weight: 500;
      }

      ul {
        margin: 1rem 0 1rem;
        list-style: none;
      }

      ul li a,
      ul li :global(a) {
        color: #333;
        text-decoration: none;
        transition: all 200ms ease-in-out;
        font-weight: 400;
        font-size: 14px;
      }

      ul li a:hover,
      ul li :global(a:hover) {
        color: #707070;
      }

      ul li a.active {
        font-weight: 500;
      }

      @media screen and (max-width: 1350px) {
        .vida-sidebar {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }

        .sidebar-group ul {
          padding: 0;
        }
      }
    `}</style>
  </>
}

export default IRWorkshopInstructionalLibrarySidebar;
